<template>
  <div class="AboutMovie">
    <!-- 相關影片 -->
    <section id="related-video" class="section-group" v-if="movielistfunc[0]">
      <h2 class="side-title">{{ $t('Video.AboutMovie.RelatedVideos') }}</h2>
      <div class="video-card card mb-1" v-for="movie in movielistfunc" v-bind:key="movie.id">
        <router-link
          @click.native="changemovie(movie.id)"
          :to="{name:'WatchVideo',params:{id:movie.id,itemtype:'video'}}"
        >
          <div class="video-block">
            <div class="video-thumbnail">
              <div class="video-responsive">
                <div class="video-sizer">
                  <div
                    class="video-image"
                    :style="{backgroundImage:'url('+`${movie.imageFile}`+'),url(' + `${require('../../assets/images/404.png')}` + ')' }"
                  ></div>
                </div>
              </div>
              <div class="video-duration">
                <span>{{movie.mov_VSourceTimeFormat}}</span>
              </div>
            </div>
          </div>
          <div class="video-info p-2">
            <div class="video-title" :title="movie.sgL_Mov_VSubject">{{movie.sgL_Mov_VSubject}}</div>
          </div>
        </router-link>
      </div>
    </section>
    <!-- /.相關影片 -->
    <!-- <button @click="tryToParent">click</button> -->
  </div>
</template>
<script>
export default {
  name: "AboutMovie",
  data() {
    return {
      movielist: [],
      vidata: null
    };
  },
  created() {
    this.$store.dispatch("updateCurrentIndex", 1);
  },
  mounted() {},
  props: ["aboutdata"],
  methods: {
    changemovie(id) {
      this.$emit("changemovie", id);
    },
    tryToParent() {
      // 通过$emit进行触发  子組件向父組件傳值
      // 第一个参数为父组件监听的事件名，后续参数为父组件方法的参数
      this.$emit("toParent", this.movielist);
    },
    async getdata() {
      let param = {
        SGL_Moive_TypeId: this.vidata.sgL_MasterSort,
        Sorting: "1",
        SkipCount: 0,
        MaxResultCount: 8
      };
      this.$api.VideoApi.VideoListDesk(param).then(res => {
        this.movielist = res.data.result.items.filter(data => {
          if (data.id != this.vidata.id) {
            return data;
          }
        });
      });
    }
  },
  watch: {
    //监听aboutdata数据变化
    aboutdata(newdata, olddata) {
      this.vidata = newdata;
      this.getdata();
      this.tryToParent();
     
    }
  },
  computed: {
    movielistfunc() {
      return this.movielist;
    }
  }

  // export default {
  //   name: 'AboutMovie',
  //   props: {
  //     msg: {
  //       type: String,
  //       default: () => {
  //         return '默认值'
  //       }
  //     }
  //   },
  //   data () {
  //     return {
  //       childrenSay: 'hello, parent'
  //     }
  //   },
  //   methods: {
  //   // 子组件通过emit方法触发父组件中定义好的函数，从而将子组件中的数据传递给父组件
  //     say () {
  //       this.$emit('say', this.childrenSay)
  //     }
  //   }
  // }
};
</script>



// WEBPACK FOOTER //
// src/components/Video/AboutMovie.vue